import axios from "axios";

import APIRoutes from "../../APIRoutes";

import ISonicChatroom from "../../../common/classes/SonicChatroom";

import { getChatRoot } from "../../../utils/GeneralUtils";
import { SonicMessage } from "../../../common/classes/SonicMessage";

/**
 * getChatRooms
 *
 * Fetching chat rooms associated with users.
 *
 * @typedof Chatroom
 * @property {ISonicChatroom} room Chat room id and users
 * @property {number} unreadCount Number of unread messages
 *
 * @param {string} auth_token The user's auth token, used for fetching data that requires certain privileges.
 * @returns {Promise<Chatroom[] | null>} An array of chatroom.
 */

export const getChatRooms = async (
  auth_token: string
): Promise<
  | {
      room: ISonicChatroom;
      unreadCount: number;
      latestMessage: SonicMessage | null;
    }[]
  | null
> => {
  try {
    const res = await axios.get(getChatRoot(APIRoutes.chat.list), {
      headers: {
        "X-Sonic-Auth": auth_token,
      },
    });

    if (res.data.result === false) return null;

    return res.data.message;
  } catch (e) {
    return null;
  }
};
